/** Effektiver Randabstand vom Dachrand (Stufe 3: einheitlich edgeM). */
export function roofEdgeSetbackM(config) {
    return Math.max(0, config.edgeM);
}
/** Sicherheitsabstand um ein Hindernis (eigener Wert vor Default). */
export function obstacleClearanceM(obstacle, config) {
    return Math.max(0, obstacle.setbackM ?? config.obstacleM);
}
/** Sperrflächen sind selbst die Grenze → kein zusätzlicher Abstand. */
export function exclusionClearanceM(_zone) {
    return 0;
}
/** Konservative Default-Randabstände (AT-Praxis-Richtwert; im Projekt zu prüfen). */
export function defaultSetbacks() {
    return {
        edgeM: 0.3,
        ridgeM: 0.3,
        eaveM: 0.3,
        vergeM: 0.3,
        obstacleM: 0.3,
        maintenancePathM: 0,
    };
}
//# sourceMappingURL=setbacks.js.map